import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal, NamedLink } from '../../components';

import css from './UserNav.module.css';

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'ManageListingsPage')
 * @returns {JSX.Element} User navigation component
 */
const UserNavComponent = props => {
  const { className, rootClassName, currentPage, onLogout } = props;
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: (
        <span className={css.tabLabel}>
          <FormattedMessage id="UserNav.myActivity" />
        </span>
      ),
      selected: currentPage === 'MyActivityPage',
      disabled: false,
      linkProps: {
        name: 'MyActivityPage',
      },
    },
    {
      text: 'My listings',
      selected: currentPage === 'ManageListingsPage',
      linkProps: {
        name: 'ManageListingsPage',
      },
    },
    {
      text: 'Create bid',
      selected:
        currentPage === 'UserSettingsPage' && window.location.search.includes('section=create-bid'),
      disabled: false,
      linkProps: {
        name: 'UserSettingsPage',
        to: { search: '?section=create-bid' },
      },
    },
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  return (
    <div className={classes}>
      <div className={css.navContainer}>
        <div className={css.tabsGroup}>
          {tabs.map((tab, index) => {
            const isSelected = tab.selected;
            const tabClasses = classNames(css.tab, {
              [css.selected]: isSelected,
            });

            return (
              <NamedLink
                key={index}
                name={tab.linkProps.name}
                params={tab.linkProps.params || {}}
                to={tab.linkProps.to || {}}
                className={tabClasses}
              >
                {tab.text}
              </NamedLink>
            );
          })}
        </div>

        {/* Logout Button */}
        <button className={css.logoutButton} onClick={onLogout} title="Log out">
          Log out
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const UserNav = connect(mapStateToProps)(UserNavComponent);

export default UserNav;
